import React from 'react';

import { getLocale } from "../utils/SettingsRetriever";

import ca from './locales/ca';
import de from './locales/de';
import en from './locales/en';
import es from './locales/es';
import fr from './locales/fr';
import it from './locales/it';
import zh from './locales/zh';
import pt from './locales/pt';

function createMarkup(text) {
    return { __html: text };
}

export default (id, isHtml = false) => {
    const languageId = getLocale();
    let locale = null;
    switch (languageId) {
        case 'ca':
            locale = ca;
            break;
        case 'de':
            locale = de;
            break;
        case 'es':
            locale = es;
            break;
        case 'fr':
            locale = fr;
            break;
        case 'it':
            locale = it;
            break;
        case 'zh':
            locale = zh;
            break;
        case 'en':
            locale = en
            break;
        case 'pt':
            locale = pt
            break;
        default:
            locale = en
            if (process.env.NODE_ENV === 'development') console.error(`[SPOTLIO Intl] Could not find language "${languageId}".`);
            break;
    }

    if (locale[id]){
        if(isHtml === true) return (<p dangerouslySetInnerHTML={createMarkup(locale[id])}></p>);
        return locale[id];
    }
    else {
        if (process.env.NODE_ENV === 'development') console.error(`[SPOTLIO Intl] Could not find key "${id}". Returining ID instead.`);
        return id;
    }

}
